import {
  Box, DashboardModule, FileUploadZone, Grid,
} from '@domain-group/suit-theme'

import useImages from '@hooks/useImages'
import useUppyImageUpload from '@hooks/useUppyImageUpload'

import InfoToolTip from '@components/InfoToolTip'

import UserImage from './UserImage'

const UserImages = (props: { userId: number }) => {
  const { userId } = props

  const imagesPayload = useImages({
    filters: {
      imageable_id: userId,
      imageable_type: 'User',
    },
    performHttpRequests: !!userId,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredImages,
    filteredImagesCount,
    hasFilteredImages,
    loading,
  } = imagesPayload

  const uppy = useUppyImageUpload(
    {
      callbacks: {
        afterAction: () => {},
      },
      imageable_id: userId,
      imageable_type: 'User',
      image_type: 'photo',
      requestOptions: {
        include_image_sizes: true,
      },
    },
    // @ts-expect-error TS2322
    [userId],
  )

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <InfoToolTip>
          Your user images will be displayed across Realhub so
          team members can easily identify you and, in the case
          of agents and team members who appear in marketing,
          they will be used across print and digital products.
          <br />
          <br />
          If your user images are going to be printed make sure they&apos;re the largest size possible.
        </InfoToolTip>
      )}
      loading={loading}
      title="User Images"
    >
      <Box flexDirection="column" padding="large">
        <FileUploadZone uppy={uppy} />

        {hasFilteredImages && (
          <Grid
            // @ts-expect-error TS2322
            gridAutoRows="1fr"
            gridColumnGap="medium"
            gridRowGap="medium"
            gridTemplateColumns="repeat(auto-fill, minmax(100px, 1fr))"
            gridTemplateRows="repeat(auto-fill, minmax(100px, 1fr))"
            marginTop="large"
          >
            {filteredImages.map(image => (
              <UserImage image={image} key={image.id} />
            ))}
          </Grid>
        )}
      </Box>

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: hasFilteredImages ? '1px solid' : 'none' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={canLoadMore ? filteredImagesCount : 0}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default UserImages
